import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HttpService } from "../services/HttpService";
import BoxShareLink from "./popUpLinkPublicCalendars/boxShareLink";

const PopUpLinkTelevisit = (props: any) => {
  const { t } = useTranslation();
  let show = props.show ?? true;
  const { eventUuid } = useSelector((state: any) => state.login);

  const closePopUp = () => {
    if (typeof props.closePopUp === 'function') {
      props.closePopUp()
    }
  }

  return (
    <Modal className="ModalSection EditCategoryTimeslot PopUpEmailSchedule =" show={show} onHide={closePopUp} >
      <Modal.Header closeButton>
        {t('links-televisit')}
      </Modal.Header>
      <Modal.Body>
        <div className="col-lg-12 ">
          <BoxShareLink label={t("links-televisit-description")} url={`${window.location.origin}/telemedicine/pharmacy/${eventUuid}`} />
        </div>
      </Modal.Body>
      <Modal.Footer>

      </Modal.Footer>
    </Modal>
  )
}

export default PopUpLinkTelevisit

